export default __webpack_public_path__ + "static/media/mobilequant.5bc483a8.svg";